import type { Row, SessionsParams } from '../../../protocol/views.ts'
import type { Group } from '../../../client/status.ts'
import type { RowFacts } from '../../../client/session-row.ts'

/** Enable each entry only with the corresponding sessions-rows core contract. */
export const sessionsCapabilities = Object.freeze({ rowFacts: false, workspace: true, keep: false, bulkRead: false, lastInput: false, continuation: false, readBoundary: false, under: false })
export type SessionsCapabilities = { readonly [K in keyof typeof sessionsCapabilities]: boolean }
export interface ReadBoundary { itemKey: string; generation: string; expectedRevision: number }
export type SessionRow = Row & RowFacts & { lastInput?: number; readBoundary?: ReadBoundary; kept?: boolean }
export type WorkspaceGroup = Group
export type PageQuery = SessionsParams & { under?: string }
/** The sole wire boundary for the additive contract; disabled fields never reach the old core. */
export const wireQuery = (query: PageQuery): SessionsParams => query as SessionsParams
